import { AppCompaniesChoices, MidGameConfiguration } from "src/types"

export const midGameConfiguration: Record<string, MidGameConfiguration> = {
    [AppCompaniesChoices["vtb"]]: {
        heading: "Ты на шаг ближе к цели!",
        description: "А вот и твой подарок — гайд о том, как поставить карьерные цели на новый год",
        button: {
            text: "Скачать чеклист",
            link: "vtb-guide.pdf"
        },
        image: "/mid-game/mid-game-vtb.png"
    },
    [AppCompaniesChoices["robo-finance"]]: {
        heading: "Супер!<br/>Ты мыслишь креативно",
        description: "А из нашего полезного материала ты узнаешь, как генерить идеи и решать творческие задачи ещё быстрее",
        button: {
            text: "Скачать материал",
            link: "robo-finance-guide.pdf"
        },
        image: "/mid-game/mid-game-robo-finance.png"
    },
    "misc": {
        heading: "Класс!<br />Осталось совсем немного",
        description: "Отгадай последний подарок — и все сотрудники будут счастливы. И не забывай про главный приз — курсы Синхронизации",
        image: "/mid-game/mid-game-misc.png",
        button: null
    },
    "h": {
        heading: "Класс!<br />Осталось совсем немного",
        description: "Отгадай последний подарок — и все сотрудники будут счастливы. И не забывай про главный приз — курсы Синхронизации",
        button: {
            text: "Скачать чеклист",
            link: "h-guide.pdf"
        },
        image: "/mid-game/mid-game-h.png"
    },
    [AppCompaniesChoices["sport-master"]]: {
        heading: "Отлично!",
        description: "Держи гайд о том, как поставить ещё больше рекордов в новом году",
        button: {
            text: "Скачать гайд",
            link: "sportmaster-guide.pdf"
        },
        image: "/mid-game/mid-game-sport-master.png"
    },
    "final": {
        heading: "Ура! У всех есть подарки",
        description: "Теперь ты знаешь, что подарить друзьям-айтишникам — а может даже и кем стать, чтобы в следующем году найти под ёлкой тот самый подарок. А чтобы не ждать целый год, скачивай полезные материалы и оставляй контакты для участия в розыгрыше",
        button: {
            text: "Скачать все материалы",
            link: "guides.zip"
        },
        image: "/mid-game/mid-game-final.png"
    }
}